var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcActualite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.9,30.6V45c0,1.6,1.3,2.9,2.9,2.9c1.6,0,2.9-1.3,2.9-2.9V31.1c0-0.3-0.3-0.6-0.6-0.6H42.9z M45.7,51.3 c-3.5,0-6.3-2.8-6.3-6.3V28.8c0-1,0.8-1.7,1.7-1.7h6.9c2.2,0,4,1.8,4,4V45C52.1,48.5,49.2,51.3,45.7,51.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,21.3H18.1c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h13.8c1,0,1.7,0.8,1.7,1.7 C33.6,20.6,32.9,21.3,31.9,21.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.9,30.3H18.1c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7h13.8c1,0,1.7,0.8,1.7,1.7 C33.6,29.5,32.9,30.3,31.9,30.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,39.9h-6.9c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7H25c1,0,1.7,0.8,1.7,1.7C26.7,39.1,25.9,39.9,25,39.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,51.3H13.4c-3.5,0-6.3-2.8-6.3-6.3V12.7c0-2.2,1.8-4,4-4h27.7c2.2,0,4,1.8,4,4v16.2c0,1-0.8,1.7-1.7,1.7 c-1,0-1.7-0.8-1.7-1.7V12.7c0-0.3-0.3-0.6-0.6-0.6H11.1c-0.3,0-0.6,0.3-0.6,0.6V45c0,1.6,1.3,2.9,2.9,2.9h32.3c1,0,1.7,0.8,1.7,1.7 C47.5,50.6,46.7,51.3,45.7,51.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActualite);
export default __webpack_public_path__ + "static/media/ic_actualite.83925616ca09e64b3b8c00c38031c5ba.svg";
export { ForwardRef as ReactComponent };